import { motion } from "framer-motion";

const chapters = [
  {
    number: "02",
    title: "Craft before category.",
    text: "Fashion, technology, and lifestyle are not separated here. They collide around one standard: objects must feel deliberate, tactile, and built to hold attention.",
    image: "https://images.pexels.com/photos/20194705/pexels-photo-20194705.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    number: "03",
    title: "Color against the void.",
    text: "Our palette is black first, electric second. Volt green and signal pink appear only when a product, moment, or action deserves voltage.",
    image: "https://images.pexels.com/photos/14713023/pexels-photo-14713023.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    number: "04",
    title: "Global taste, personal ritual.",
    text: "BKG Global sources for movement across cities, studios, airports, and nights that deserve better equipment.",
    image: "https://images.pexels.com/photos/14582250/pexels-photo-14582250.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export function Manifesto() {
  return (
    <section id="manifesto" className="border-t border-white/10 px-5 py-28 lg:px-10 lg:py-40" data-testid="manifesto-section">
      <div className="mb-20 max-w-3xl">
        <p className="text-xs font-bold uppercase tracking-[0.28em] text-volt">Manifesto</p>
        <h2 className="mt-4 font-heading text-5xl font-black italic tracking-tighter md:text-7xl">Not a store. A signal.</h2>
      </div>
      <div className="space-y-28">
        {chapters.map((chapter, index) => (
          <motion.div key={chapter.number} initial={{ opacity: 0, y: 60 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-120px" }} transition={{ duration: 0.7 }} className={`grid items-center gap-10 lg:grid-cols-12 ${index % 2 ? "lg:text-right" : ""}`}>
            <div className={`relative lg:col-span-5 ${index % 2 ? "lg:order-2" : ""}`}>
              <span className="absolute -top-20 left-0 font-heading text-[10rem] font-black italic leading-none text-outline opacity-50">{chapter.number}</span>
              <div className="product-frame relative z-10 aspect-[4/5] overflow-hidden border border-white/10 bg-zinc-900">
                <img src={chapter.image} alt={chapter.title} loading="lazy" className="h-full w-full object-cover" />
              </div>
            </div>
            <div className={`lg:col-span-6 ${index % 2 ? "lg:order-1" : "lg:col-start-7"}`}>
              <h3 className="font-heading text-4xl font-black italic tracking-tighter md:text-6xl">{chapter.title}</h3>
              <p className={`mt-6 max-w-xl text-base font-light leading-relaxed text-zinc-400 md:text-lg ${index % 2 ? "lg:ml-auto" : ""}`}>{chapter.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
